export default __webpack_public_path__ + "static/media/iam_s2.3a79c51f.png";